export const headerData = {
  /** CDN hero for home Header + mobile strip (Mumbai / Pune / Bangalore) */
  homeHeroImageUrl:
    'https://cdn.snageasy.in/app-img/webp/home_inspection_service_in_mumbai_pune_and_bangalore.webp',

  badge: {
    text: "Professional Home Inspection Services",
    icon: "CheckCircleIcon"
  },
  defaultTitles: [
    "Quality Home Inspections for Quality Living",
    "Professional Home Inspection Services",
    "Your Trusted Home Inspection Partner"
  ],
  defaultDescriptions: [
    "Invest 0.1% More to Extend the Life of Your Home",
    "Comprehensive inspection services for your peace of mind",
    "Expert inspectors ensuring your home is safe and sound"
  ],
  cta: {
    primary: {
      text: "Request Callback",
      icon: "PhoneIcon",
      arrow: "ArrowForwardIcon"
    },
    secondary: {
      text: "Our Offers",
      arrow: "ArrowForwardIcon"
    }
  },
  stats: [
    {
      number: "1300+",
      label: "Homes Inspected"
    },
    {
      number: "100%",
      label: "Client Satisfaction"
    },
    {
      number: "24hrs",
      label: "Report Delivery"
    }
  ],
  image: {
    alt:
      'Professional home inspection service in mumbai, pune and bangalore'
  }
};
